import React from 'react';
import {Container, Grid, Typography} from "@mui/material";
import {convertImagePath} from "../../../../stores/tools/commons";
import Image from "next/image";
import LinkButton from "../../../atoms/LinkButton";
import colorPalette from "../../../../styles/theme/colorPalette";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import {css} from "@emotion/react";

const Reason = () => {
  return (
      <div css={wrapper} id={'reason'}>
        <Container css={{maxWidth: '600px'}}>
          <div css={{marginBottom: '32px'}}>
            <Typography variant={'h1'} css={title}>
              <span>なぜミールタイムが選ばれ続けるのか</span>
            </Typography>
            <div css={subtitle}>
              ミールタイム栄養士がお答えします！
            </div>
          </div>
          <ReasonCard
              index={1}
              title={<span>電話オペレーターが<span css={emphasis}>100%栄養士</span></span>}
              name={'suzuki-a'}
              qualification={'栄養士'}
              text={{
                1: 'ミールタイムは、お客様の「数値改善」にこだわっております。',
                2: 'そのため、100%管理栄養士もしくは栄養士がお電話でご注文を承ります。'
              }}
          >
            <LinkButton
                text={'栄養士おまかせ定期便'}
                href={'/teiki'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.primary}
                endAdornment={ <ArrowRightIcon /> }
                css={btnStyle}
            />
          </ReasonCard>
          <ReasonCard
              index={2}
              title={<span><span css={emphasis}>数値改善</span>が実現しやすい</span>}
              name={'mamiya'}
              qualification={'管理栄養士'}
              text={{
                1: 'ミールタイムで血液検査結果の数値改善が実現しやすい理由は、食事療法を継続しやすいからです。',
                2: 'そして、「継続」できる理由は、ミールタイムの栄養士によるサポートと、温めるだけで手軽に食べられる栄養価が調整された宅配食にあります。'
              }}
          />
          <ReasonCard
              index={3}
              title={<span><span css={emphasis}>お客様の声</span>を取り入れるメニュー開発</span>}
              name={'oura'}
              qualification={'管理栄養士'}
              text={{
                1: '開発モットーとして【商品・サービスは今日も改善、明日も改善、永遠に改善】を掲げています。',
                2: 'ミールタイム栄養士ならではの驚きと感動をご提供できるようなメニューの開発に努めて参ります！'
              }}
          />
          <ReasonCard
              index={4}
              title={<span><span css={emphasis}>病院・調剤薬局</span>の推薦</span>}
              name={'henmi'}
              qualification={'管理栄養士'}
              text={{
                1: '医療機関様や栄養士様より「ミールタイムさんのようなサポートがあると安心です」というご意見を頂きます。',
                2: '医療機関様で制限数値や注意点が出ていれば、しっかりその数値に合わせたお食事をお届け致します。'
              }}
          />
          <ReasonCard
              index={5}
              title={<span><span css={emphasis}>翌日配達・送料全国一律</span></span>}
              name={'kamizono'}
              qualification={'管理栄養士'}
              text={{
                1: '平日13時00分までにご注文して頂ければ、翌日配達が可能でございます。',
                2: 'ご利用頂いている多くのお客様が送料が安くなるように、まとめてお食事をご注文していただいております。'
              }}
          />
          <div css={{display:'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <LinkButton
                text={'詳しく見る'}
                href={'/reason'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.primary}
                endAdornment={ <ArrowRightIcon /> }
                css={btnStyle}
            />
            <LinkButton
                text={'栄養士一覧'}
                href={'/dietitians'}
                maxWidth={"300px"}
                hexColorCode={colorPalette.primary}
                endAdornment={ <ArrowRightIcon /> }
                css={btnStyle}
            />
          </div>
        </Container>
      </div>
  );
};

export default Reason;

const ReasonCard = (props) => {
  return (
      <div css={{marginBottom: '24px'}}>
        <div css={indexStyle}>
          <div><span className={'index'}>{ props.index }</span><span className={'title'}>{ props.title }</span></div>
        </div>
        <Grid container alignItems={'center'} justifyContent={'center'}>
          <Grid item xs={12} md={5}>
            <div css={profile}>
              <div className={'dietitianImage'}>
                <Image
                    src={`${convertImagePath(
                        `reason/${props.name}.jpeg`
                    )}`}
                    alt={`${props.name}`}
                    width={150}
                    height={150}
                />
              </div>
              <div>
                <div className={'qualification'}>{ props.qualification }</div>
                <div className={'nameImage'}>
                  <Typography variant="h4">
                    <Image
                        src={convertImagePath(
                            `name/mt_left_${props.name}.png`
                        )}
                        width={100}
                        height={25}
                        alt={`${props.name}`}
                    />
                  </Typography>
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} md={7}>
            <div css={textStyle}>
          <span css={emphasis}>
            {
              props.text['1']
            }
          </span>
              <span>
            {
              props.text['2']
            }
          </span>
            </div>
          </Grid>
        </Grid>
        <div css={{display:'flex', justifyContent: 'center', alignItems: 'center'}}>
          {
            props.children
          }
        </div>
      </div>
  );
};

const title = css`
  font-weight: bold;
  color: white;
  text-shadow: 0 2px 10px #ff5324;
  padding: 1rem;
`

const subtitle = css`
  background-color: white;
  padding: 0.5rem 1rem;
  max-width: 300px;
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;
  color: ${colorPalette.primary};
  font-weight: bold;
`

const emphasis = css`
  color: ${colorPalette.primary};
`

const wrapper = css`
  padding: 24px 0;
  background: ${colorPalette.primaryGradient.rgb};
  background: ${colorPalette.primaryGradient.gradient};
`

const indexStyle = css`
  background-color: white;
  padding: 1rem;
  margin: 1rem 0;
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .index {
    width: 35px;
    text-align: center;
    margin-right: 1rem;
    background-color: ${colorPalette.primary};
    color: white;
    font-size: 2rem;
    font-weight: bold;
  }
  .title {
    color: ${colorPalette.primary};
    font-size: 2rem;
    font-weight: bold;
  }
`

const profile = css`
  display: flex;
  flex-direction: row;
  align-items: center;
  .dietitianImage {
    width: 120px;
  }
  .qualification, .nameImage {
    padding: 0.5rem 1rem;
  }
`

const textStyle = css`
  background-color: white;
  border-radius: 8px;
  padding: 1rem;
  font-size: 1.4rem;
  margin-bottom: 1rem;
`

const btnStyle = css`
  background-color: white;
  margin: 0.5rem 0;
`